import React, { FC } from "react";
import cn from "classnames";
import { Editor } from "@tiptap/react";
import { camelize } from "src/utils/camelize";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { IListButton } from "./types";

interface Props extends IListButton {
  editor: Editor;
}
export const ListButton: FC<Props> = ({ editor, listType, icon: Icon }) => {
  const isActive = editor.isActive(listType);

  const onClick = () => {
    const methodName = camelize(`toggle ${listType}`); // ex. toggle orderedList => toggleOrderedList
    editor.chain().focus()[methodName]?.().run();
  };

  return (
    <Button
      type="button"
      variant={isActive ? ButtonVariants.PRIMARY : ButtonVariants.SECONDARY}
      className="!rounded-md !duration-100 !p-1"
      onClick={onClick}
    >
      <Icon
        title={listType}
        className={cn("w-5 h-5 transition-colors duration-100", {
          "text-black-base ": !isActive,
          "text-white-base": isActive,
        })}
      />
    </Button>
  );
};
